import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import * as serviceWorker from "./serviceWorker";
import setAuthToken from "./utils/setAuthToken";
import axios from "axios";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
// import { Toast } from "react-bootstrap";
import { setLoginErrorMessage } from "./actions/authActions";
import store from "./store";
import { USER_REQUEST_ERROR } from "./actions/types";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

let lastBusinessIdWithError = null;
let lastNetworkErrorBusinessId = null;

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

axios.interceptors.request.use(
  async config => {

    var dateTimeNow = new Date();
    var token_expired_at = '';

    if (localStorage.headers) {
      if (JSON.parse(localStorage.headers)?.data?.token_expired_at) {
        token_expired_at = JSON.parse(localStorage.headers)?.data?.token_expired_at;
        token_expired_at = new Date(token_expired_at);
      }
    }

    config.headers = {
      'Authorization': `Bearer ${JSON.parse(localStorage.getItem("headers")) && JSON.parse(localStorage.getItem("headers")).data.token}`
      // 'Accept': 'application/json',
      // 'Content-Type': 'application/x-www-form-urlencoded'
    }

    // token expired, logout user
    if (localStorage.login && token_expired_at !== '' && dateTimeNow > token_expired_at) {
      alert('Token expired! Redirect to login page.');
      var newHeaders = JSON.parse(localStorage.headers);
      newHeaders.data.token_expired_at = '';

      localStorage.setItem('headers', JSON.stringify(newHeaders));

      axios
        .get('/auth/customer_logout')
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });

      localStorage.clear();
      window.location.reload();
    }

    return config;
  },
  error => {
    Promise.reject(error)
  });


axios.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("------------------------ RESPONSE INTERCEPTED ----------------------------");
    const currentBusinessId = localStorage.getItem("business_id");
    if (error.message === "Network Error" && !error.response) {
      if (lastNetworkErrorBusinessId !== currentBusinessId) {
        lastNetworkErrorBusinessId = currentBusinessId;
        toast.error(error.message || "Network Error");
      }
      // if (currentPath !== "/Error") {
      //   window.location.href = "/Error";
      // }
      return Promise.reject(error);
    }

    if (!error.response) {
      return Promise.reject(error);
    }

    const { status, data, config } = error.response;

    const userErrorMessages = ["Email is not verified", "Email is terminated", "Unauthorized"];
    if (userErrorMessages.includes(data.message)) {
      store.dispatch(setLoginErrorMessage(error.response));
    }

    if (status === 401) {
      toast.error(data.message || "Unauthorized");
    }

    if (status === 404) {
      console.warn("Page not found:", config?.url);

      if (config?.url?.startsWith("/password/find")) {
        store.dispatch({
          type: USER_REQUEST_ERROR,
          payload: error.response,
        });
      }
    }

    if (status === 400 && config.method === "get" && data.errors?.id) {
      console.warn("Bad request - ID not found.");
      toast.error("Bad request - ID not found.");
    }

    if (status === 500) {
      const currentBusinessId = localStorage.getItem("business_id");

      if (lastBusinessIdWithError !== currentBusinessId) {
        lastBusinessIdWithError = currentBusinessId;
        toast.error("Invalid request.");
      }
    }
    // if (currentPath !== "/Error") {
    //   // window.location.href = "/Error";
    //   toast.error("Server error - check the terminal for more info!");
    // }
    return Promise.reject(error);
  }
);


// console.log(localStorage.headers);

if (localStorage.headers) {
  const accessToken = `Bearer ${JSON.parse(localStorage.getItem("headers")) &&
    JSON.parse(localStorage.getItem("headers")).data.token
    }`;
  setAuthToken(accessToken);
}

function noop() { }

if (process.env.NODE_ENV !== "development") {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

noop();

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <App />
    <ToastContainer position="top-right" autoClose={3000} theme="colored" style={{ zIndex: 100001 }} />
  </I18nextProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorker.unregister();
